import { axiosInstance } from './axiosConfig';

export const getScreenCapturesBySrId = (srId) => axiosInstance
  .get(`screenCaptures/${srId}`)
  .then((response) => response.data)

export const deleteScreenCaptureBySrId = (srId, type) => axiosInstance
  .delete(`screenCaptures/${srId}?type=${type}`)
  .then((response) => response.data);
